import { t } from 'i18next'

import Tooltip from '~/components/Tooltip'
import { isImpressionShareFamilyAbsent } from '~/modules/retailMedia/helpers/newMetricsAvailability'

type ImpressionShareMetricCellProps = {
  value?: React.ReactNode
  raw?: Record<string, unknown> | null
}

/**
 * Renders an IS metric cell. When the Impression Share family keys are absent
 * (entitlement/permission off), shows "-" with an explanatory tooltip.
 * When keys are present but null/empty, shows plain "-" (no-data).
 */
export function ImpressionShareMetricCell({
  value,
  raw
}: Readonly<ImpressionShareMetricCellProps>) {
  if (isImpressionShareFamilyAbsent(raw)) {
    return (
      <Tooltip
        noMargin
        icon={<span>-</span>}
        text={t('rm:metrics.impressionShare.notEnabledForPublisher')}
      />
    )
  }

  return <>{value || '-'}</>
}
